import { useEffect, useState } from "react"

// QUERIES
import { KURSIST_COUNT, UPDATE_KURSISTER, KURSISTER } from '../../../../queries/kursister.gql'
import { CREATE_JOBCENTER, UPDATE_JOBCENTER, DELETE_JOBCENTER } from '../../../../queries/catalogs/jobcentre.gql'
import { ALL_CATALOGS } from '../../../../queries/catalogs/allCatalogs.gql'

// HOOKS
import { useCatalog } from "../../../../hooks/useCatalog"

// COMPONENTS
import { AdminInterfaceTemplate } from "../AdminInterfaceTemplate/AdminInterfaceTemplate"
import CheckboxInput from "../../../Inputs/CheckboxInput/CheckboxInput"
import Input from "../../../Inputs/Input"

let lastData = [] 
let changeTimeStamp = new Date().valueOf();
const primaryKey = "Jobcenter_id"

export default function AdminInterfaceJobcentre() {
    const catalogs = useCatalog()
    const content = catalogs.jobcentre

    const [newContent, setNewContent] = useState(content)
    const [searchString, setSearchString] = useState("")
    const [sort, setSort] = useState({field: "", dir: false})
    const [selected, setSelected] = useState(null)
    const [newObj, setNewObj] = useState(null)
    const [scrollToBottom, setScrollToBottom] = useState(false)
    const [customLoading, setCustomLoading] = useState(false)

    useEffect(() => {
        const filtered = AdminInterfaceTemplate.functions
        .localSearch(searchString, content, ["Jobcenter", "Region"])
        setNewContent(filtered)
    },[searchString])

    useEffect(() => {
        const sorted = AdminInterfaceTemplate.functions.localSort(newContent, sort)
        setNewContent(sorted)
    },[sort])

    useEffect(() => {
        if (customLoading)
            setCustomLoading(false)

        if (sort.field) {
            const sorted = AdminInterfaceTemplate.functions.localSort(content, sort)
            setNewContent(sorted)
        } else {
            setNewContent(content)
        }
        if (content.toString() != lastData.toString()) {
            changeTimeStamp = new Date().valueOf();
            lastData = content
        }
    },[content])

    const event = {
        search: (name, val) => {
            setSearchString(val)
        },
        sort: (field) => {
            setSort({field: field, dir: !sort.dir})
        },
        rowClick: (val, index) => {
            setNewObj(null)
            setSelected(val)
        },
        UpdateInput: (name, val) => {
            let updateObj = {...selected}
            updateObj[name] = val
            setSelected(updateObj)
        },
        createInput: (name, val) => {
            let updateObj = {...newObj}
            updateObj[name] = val
            setNewObj(updateObj)
        },
        new: () => {
            setSelected(null)
            setNewObj({
                Jobcenter: "",
                Region: "",
                Aktivt: false
            })
        },
        createSuccess: (res) => {
            setSearchString("")
            setSelected(res)
            setScrollToBottom(true)
        },
        createStart: () => {
            setCustomLoading(true)
        },
        updateSuccess: (id) => {
            setSearchString("")
            setCustomLoading(false)
        },
        updateStart: () => {
            setCustomLoading(true)
        },
        deleteStart: () => {
            const htmlRow = document.querySelector(`[data-primary-key="${primaryKey}${selected[primaryKey]}"]`)
            htmlRow.classList.add("inactive_load")
            setCustomLoading(true)
        },
        deleteSuccess: () => {
            setSearchString("")
            setSelected(null)
            setNewObj(null)
        },
        moveStart: () => {
            setCustomLoading(true)
        },
        moveSuccess: () => {
            setSearchString("")
            setCustomLoading(false)
        }
    }

    console.log(newObj)
    return (
        <AdminInterfaceTemplate.component>
            <AdminInterfaceTemplate.content>
                <AdminInterfaceTemplate.table 
                    primaryKey={primaryKey}
                    changeTimeStamp={changeTimeStamp}
                    scrollToBottom={scrollToBottom}
                    setScrollToBottom={setScrollToBottom}
                    onNew={event.new}
                    searchFunction={event.search}
                    searchString={searchString}
                    content={newContent}
                    selected={selected}
                    rowClick={event.rowClick}
                    rowSelect={!selected ? null : {field: primaryKey, value: selected.Jobcenter_id}}
                    cells={[
                        {
                            size: 0,
                            title: "ID",
                            name: "Jobcenter_id",
                            sort: sort,
                            onClick: () => event.sort("Jobcenter_id")
                        },
                        {
                            size: 1,
                            title: "Jobcenter",
                            name: "Jobcenter",
                            sort: sort,
                            onClick: () => event.sort("Jobcenter")
                        },
                        {
                            size: 1,
                            title: "Region",
                            name: "Region",
                            sort: sort,
                            onClick: () => event.sort("Region")
                        },
                        {
                            size: 0,
                            title: "Aktiv",
                            name: "Aktivt",
                            sort: sort,
                            onClick: () => event.sort("Aktivt")
                        }
                    ]}
                />
                {/* `{{count}} Kursister er medlem af {{title}}, sletning er ikke opfordret! */}
                {selected ? 
                    <AdminInterfaceTemplate.update
                        variables={{
                            id: selected.Jobcenter_id,
                            input: {
                                Jobcenter: selected.Jobcenter,
                                Region: selected.Region,
                                Aktivt: selected.Aktivt
                            }
                        }}
                        updateQuery={UPDATE_JOBCENTER}
                        deleteQuery={DELETE_JOBCENTER}
                        refetchQueries={[ALL_CATALOGS]}
                        title={`${selected.Jobcenter} - ${selected.Region}`}
                        id={selected.Jobcenter_id}
                        countQueryObj={{
                            query: KURSIST_COUNT,
                            variables: {
                                conditions: {
                                    Jobcenter: selected.Jobcenter_id
                                }
                            },
                            loading: "Checkker Jobcenter...",
                            warning: "{{count}} kursister er medlem af {{title}}, Sletning er ikke opfordret!",
                            goTo: {
                                text: "Find kursisterne",
                                path: "/kursister",
                                value: `Jobcenter_id=${selected.Jobcenter_id}`
                            },
                            move: {
                                query: UPDATE_KURSISTER,
                                variables: {
                                    field: `Jobcenter`,
                                    from: selected.Jobcenter_id,
                                    title: `${selected.Jobcenter} - ${selected.Region}`
                                },
                                refetchQueries: [KURSISTER, KURSIST_COUNT, ALL_CATALOGS],
                                onMoveStart: event.moveStart,
                                onMoveSuccess: event.moveSuccess,
                                text: "Skift kursisternes Jobcenter",
                                menuText: "Skift Jobcenter for {{count}} kursister?",
                                selectOptions: content.map(obj => ({value: obj.Jobcenter_id, title: `${obj.Jobcenter} - ${obj.Region}`})),
                            },
                            delete: {
                                text: "Handlingen vil forsøge at nulstille jobcenter værdierne for {{count}} kursister, er du sikker på du ikke vil ændre jobcenter værdierne først?"
                            }
                        }}
                        customLoading={customLoading}
                        onUpdateStart={event.updateStart}
                        onUpdateSuccess={event.updateSuccess}
                        onDeleteStart={event.deleteStart}
                        onDeleteSuccess={event.deleteSuccess}
                    >
                        <Input 
                            label="Jobcenter" 
                            name="Jobcenter" 
                            value={selected.Jobcenter} 
                            onInput={event.UpdateInput} 
                        />
                        <Input 
                            label="Region" 
                            name="Region" 
                            value={selected.Region} 
                            onInput={event.UpdateInput} 
                        />
                        <CheckboxInput 
                            label="Aktiv"
                            name="Aktivt"
                            value={selected.Aktivt}
                            onInput={event.UpdateInput} 
                        />
                    </AdminInterfaceTemplate.update>
                : newObj ?
                    <AdminInterfaceTemplate.create
                        variables={{
                            input: {...newObj}
                        }}
                        createQuery={CREATE_JOBCENTER}
                        refetchQuery={ALL_CATALOGS}
                        customLoading={customLoading}
                        onCreateSuccess={event.createSuccess}
                        onCreateStart={event.createStart}
                    >
                        <Input 
                            label="Jobcenter" 
                            name="Jobcenter" 
                            value={newObj.Jobcenter} 
                            onInput={event.createInput} 
                        />
                        <Input 
                            label="Region" 
                            name="Region" 
                            value={newObj.Region} 
                            onInput={event.createInput} 
                        />
                        <CheckboxInput 
                            label="Aktiv"
                            name="Aktivt"
                            value={newObj.Aktivt}
                            onInput={event.createInput} 
                        />
                    </AdminInterfaceTemplate.create>
                : <AdminInterfaceTemplate.empty />}

            </AdminInterfaceTemplate.content>
        </AdminInterfaceTemplate.component>
    )
}